module.exports = __webpack_public_path__ + "img/4.1.b2b4dae9.png";